<template>
  <div class="auxiliaryLine" :style='style'>

  </div>
</template>

<script>

export default {
  props: ["datas"],
  data() {
    return {

    };
  },
  computed: {
      style(){
          return `margin-left:${this.datas.num/37.5}rem;margin-right:${this.datas.num/37.5}rem;border-style: ${this.datas.style};border-color:${this.datas.color}`
      }
  }


};
</script>
<style lang="less" scoped>
@import url("~@/styles/mixin.less");
.auxiliaryLine {
    margin: 0.4rem 0;
    border-width: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/AuxiliaryLine.vue